import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MainContainer = styled.div`
  padding-top: 3rem;
`;
